"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
    Project
    
    All project specific translations
    
    Verified by: Cédric Bloem
    Date: 12/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
var Projects = {
  // ESN Management
  esn_management_login: {
    nl: 'Meld je aan op OSN Management',
    fr: 'Connectez-vous à OSN Management',
    en: 'Log into OSN Management'
  },
  esn_management_description: {
    nl: 'Met OSN Management kunt u alle gegevens van ondernemers op het Ondernemersnetwerk beheren, zoals openingstijden, advertenties, videotheek en meer.',
    fr: "Avec OSN Management, vous pouvez gérer toutes les données des entrepreneurs sur le Réseau Entrepreneurs, telles que les heures d'ouverture, la publicité, la vidéothèque, etc.",
    en: 'With OSN Management, you can manage all the the entrepreneurs data of the Entrepreneurs Network such as opening hours, advertisement, video library and more.'
  }
};
var _default = Projects;
exports["default"] = _default;